import React, { useCallback } from 'react';
import { TextInput } from '../../../TextInput';
export var FilterEditorNumberCondition = function FilterEditorNumberCondition(_ref) {
  var condition = _ref.condition,
      conditionValue = _ref.conditionValue,
      onConditionValueChange = _ref.onConditionValueChange;
  var label = condition.label;

  var _ref2 = conditionValue || {},
      value = _ref2.value;

  var onChange = useCallback(function (event) {
    onConditionValueChange({
      value: parseInt(event.target.value, 10)
    });
    event.stopPropagation();
  }, [onConditionValueChange]);
  return React.createElement(TextInput, {
    type: "number",
    wide: true,
    label: label,
    value: value || '',
    onChange: onChange,
    autoComplete: "nope"
  });
};